module.exports = __webpack_public_path__ + "static/media/last-page.90fe59ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/last-page.svg
// module id = 860
// module chunks = 0